import { create } from 'zustand'
import { persist } from 'zustand/middleware'


const setUserStore = (set) => ({
    welcomeMessage : 'Welcome yung ',
    userName : 'Joshwa',
    cardCols : 3,
    editMode : true,
    noteText : '...',
    displayNote : false,
    displayTodos : true,
    displayCards : true,
    displayWeather : true,

    setWelcomeMessage: ( message ) => set( () => ({ welcomeMessage :  message })  ),
    setUserName: ( name ) => set( () => ({ userName : name }) ),
    setCardCols: ( number ) => set( () => ({ cardCols : number }) ),
    setNoteText: ( message ) => set( () => ({ noteText :  message })  ),
    toggleEditMode: () => set( state => ({ editMode : !state.editMode }) ),
    toggleDisplayNote: () => set( state => ({ displayNote : !state.displayNote }) ),
    toggleDisplayTodos: () => set( state => ({ displayTodos : !state.displayTodos }) ),
    toggleDisplayCards: () => set( state => ({ displayCards : !state.displayCards }) ),
    toggleDisplayWeather: () => set( state => ({ displayWeather : !state.displayWeather }) )
})


const persistUserStore = persist(setUserStore, { name: 'jd_user_store' })

const useUserStore = create(  persistUserStore )

export { useUserStore }